import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, NgModule, OnInit } from '@angular/core';
import { WidgetPlaceholderModule } from '@app/components/widget-placeholder/widget-placeholder.component';
import { SearchResult } from '@app/models/search-result';
import { LinkModule } from '@app/directives/link.directive';
import { EditorTrendingNewsService } from '@app/services/editor-trending-news.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-find-information-trending-pages',
  templateUrl: './find-information-trending-pages.component.html',
  styleUrls: ['./find-information-trending-pages.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FindInformationTrendingPagesComponent implements OnInit {

  trendingPages$: Observable<SearchResult[]>;
  @Input() trendingPageCount = 4;
  constructor(private service: EditorTrendingNewsService) { }

  ngOnInit() {

    this.trendingPages$ = this.service.getTrendingPages(this.trendingPageCount)
      .pipe(map((pages) => {
        return pages
          .map(page => {
            return new SearchResult({
              Path: page.Path,
              Title: page.Title,
            });
          });
      }));
  }

}
@NgModule({
  declarations: [FindInformationTrendingPagesComponent],
  exports: [
    FindInformationTrendingPagesComponent
  ],
  imports: [
    CommonModule,
    WidgetPlaceholderModule,
    LinkModule
  ]
})
export class FindInformationTrendingPagesModule { }
